module.exports = __webpack_public_path__ + "static/media/download.27621576.svg";